export enum PanoramaEventType {
	SAVED_SNAPSHOT = 'SAVED_PANORAMA_TOUR_SNAPSHOT'
}